import sessionStorage from "redux-persist/lib/storage/session"; // ← Use sessionStorage instead!

export function persistConfigGenerator (key) {
  return {
    key, 
    storage: sessionStorage,
  }
}